import React from 'react';
import './cardthree.css';
export default function CardThree({head, text, image}) {
    return (
        <div data-aos='zoom-out-down' className="cardThree__main">
            <div className="cardThree__body">
                <img src={image} alt="" />
                <h4 className="head__four">
                {head}
                </h4>
                <p className="paragraph">
                  {text}
                </p>
            </div>
        </div>
    )
}
